import { Button } from "@progress/kendo-react-buttons";
import {
  ListView,
  ListViewFooter,
  ListViewHeader,
} from "@progress/kendo-react-listview";
import { useNavigate } from "react-router-dom";
import { ClientRoutes } from "../../../Constants/ClientRoutingConstants";
import { enMessages } from "../../../messages/en-US";
import { useLocalization } from "@progress/kendo-react-intl";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { getCriticalityIcon } from "../../Shared/Utilities/criticalityIcon";
import { getNotificationLink } from "../Utilities/notificationLink";

interface Props {
  notifications: any;
  handleShow: () => void;
}

export default function NotificationsPopUp(props: Props) {
  const localizationService = useLocalization();
  const navigate = useNavigate();

  const MyHeader = () => {
    return (
      <ListViewHeader
        style={{
          fontSize: 19,
          borderBottom: "1px solid #dee2e6",
        }}
        className="pl-3 pb-2 pt-2"
      >
        <div>
          {localizationService.toLanguageString(
            "custom.notifications",
            enMessages.custom.notifications
          )}
        </div>
      </ListViewHeader>
    );
  };
  const MyFooter = () => {
    return (
      <ListViewFooter
        style={{
          borderTop: "1px solid #dee2e6",
        }}
        className="pb-2 pt-2 text-center"
      >
        <div>
          <Button
            className="mark-button"
            size={"small"}
            title="Notifications"
            onClick={() => {
              navigate(ClientRoutes.NotificationsPage);
              props.handleShow();
            }}
          >
            {localizationService.toLanguageString(
              "custom.showAllNotifications",
              enMessages.custom.showAllNotifications
            )}
          </Button>
        </div>
      </ListViewFooter>
    );
  };
  const MyItemRender = (props) => {
    let item = props.dataItem;
    const link = getNotificationLink(item.metadata);

    const content = (
      <div
        className=" flex gap-2 items-center p-2 border-bottom align-middle"
        style={{
          margin: 0,
        }}
      >
        <Tooltip position={"bottom"} anchorElement={"target"}>
          <div className="col-2">
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '26px',
                height: '26px',
                cursor: 'pointer',
              }}
              title={item.criticality}
            >
              {getCriticalityIcon(item.criticality, 'large')}
            </span>
          </div>
        </Tooltip>
        <div className="col-6 px-3">
          <div
            style={{
              marginBottom: 0,
            }}
          >
            {item.name}
          </div>
          <div
            style={{
              fontSize: 12,
              marginBottom: 0,
            }}
          >
            {item.created}
          </div>
        </div>
      </div>
    );

    // Link the whole item to the asset dashboard (new tab), or plain text if no link.
    return link ? (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="block text-inherit no-underline hover:bg-gray-100"
      >
        {content}
      </a>
    ) : (
      content
    );
  };

  return (
    <div className="mt-2" style={{ width: "300px" }}>
      <ListView
        className="max-h-96"
        data={props.notifications}
        item={MyItemRender}
        style={{
          width: "100%",
        }}
        header={MyHeader}
        footer={MyFooter}
      />
    </div>
  );
}
